/**
 * Results
 *
 * View that interactions on the results list
 *
 * @return {View}
 */

OT.createNS('OT.Redesign.Views.Results.Results');

OT.Redesign.Views.Results.Results = Backbone.ViewManager.BaseView.extend({
    el: '#search_results',

    events: {},

    initialize: function () {
        var self = this;

        // Listen for result updates
        OT.Events.on('results:updated', function () { self.render(); });

        var searchData = OT.Search.Data.get();
        // Set information about filters
        this.currentSort = searchData.Request.SortString;

        // Initialise lazy loading of restaurant images
        setTimeout(OT.Common.LazyLoadImages.init);

        if (searchData.Experiments.sfx489) {
            OT.Search.Params.set({
                size: 100,
                for_deferred: true,
                force_top_rid: searchData.Results.RestaurantIds[0],
                jarring_cues: {
                    popRids: $("#poptable-results .result")
                        .get()
                        .map($)
                        .map(function ($e) { $e.attr("data-rid"); }),
                    pinnedRids: $(".exact-match .result")
                        .get()
                        .map($)
                        .map(function ($e) { $e.attr("data-rid"); })
                }
            });
            OT.Search.Requests.Results.get({
                additionalData: { supressHistory: true }
            });
            OT.Search.Params.set({
                for_deferred: undefined,
                force_top_rid: undefined,
                jarring_cues: undefined
            });
        }

        if (this.hasNoResults(searchData)) {
            // TODO: Reimplement this using Google Tag Manager to avoid timer hacks.
            var sent = this.sendNoResultsGAEvent();
            if (!sent) {
                setTimeout(this.sendNoResultsGAEvent, 500);
            }
        }

        new OT.Redesign.Views.SearchTabs();
        (new OT.Redesign.Views.Filters.Sort());

        this.shortlistButton = [];
        $('.shortlist-button-container').each(function (index) {
            self.shortlistButton[index] = new OT.Redesign.Views.Results.ShortlistButton({ el: $(this) });
        });
    },

    hasNoResults: function (data) {
        // server-side logic can be found in app/views/ejs-templates/Home/RedesignIndex.ejs
        // please keep in sync.
        return data.Results.Total === 0 && (!_.isObject(data.Results.AddonsRestaurant) || data.Results.AddonsRestaurant.Total === 0);
    },

    sendNoResultsGAEvent: function () {
        if (_.isFunction(window.ga)) {
            ga('gtm1.send', {
                hitType: 'event',
                eventCategory: 'search-results-node',
                eventAction: 'noResults'
            });
            return true;
        }
        return false;
    },

    beforeRender: function () {
        if (OT.Search.Helpers.isMapShowing()) {
            this.unsetView();
            return false;
        }

        OT.Events.fire('results:before-render');

        this.template = 'Redesign/Results/_ResultsTable';
        this.templateData = OT.Search.Data.get();
        this.$el.show();

        // If it's not an availability request, then we want to bug out here
        if (!this.templateData.Request.IsAvailabilityRequest) {
            return true;
        }

        // If it is an availability request, then we want to render the correct
        // view based on the results total
        if (this.hasNoResults(this.templateData)) {
            this.sendNoResultsGAEvent();
            this.template = "Redesign/Results/_NoResults";
            this.additionalData = {
                clearLastFilter: OT.Search.History.count() > 1
            };
        }

        return this;
    },

    onRender: function () {
        var self = this;

        setTimeout(function () {
            OT.Common.LazyLoadImages.init();
            new OT.Redesign.Views.SearchTabs();
            (new OT.Redesign.Views.Filters.Sort);
        });
        OT.Search.recentlyBooked();
        OT.Search.stylesheet();

        self.shortlistButton.forEach(function (button) { button.dispose() });
        this.shortlistButton = [];

        $('.shortlist-button-container').each(function (index) {
            self.shortlistButton[index] = new OT.Redesign.Views.Results.ShortlistButton({ el: $(this) });
        });

        // The ping event requests an update from the shortlist widget.
        // The shortlist will respond by sending a "shortlist:updated" event with
        // the details of which restaurants are in the shortlist.
        OT.Events.fire('shortlist:ping');
        OT.Events.fire('results:rendered');

        var ocShortlistWidget = this.$el.find('oc-component.oc-shortlist-widget');
        window.oc.renderNestedComponent(ocShortlistWidget)
    },
});
